@if (loginFailed()) {
  <p>{{ 'onegate.login.error.title' | translate }}</p>
} @else if ((user$ | async) && loaded()) {
  <router-outlet />
}
